"use client";

import { RefreshCw } from 'lucide-react';

/** PWA “new build available” banner — Activate + reload when the user confirms. */
export default function UpdatePrompt({
  onUpdate,
  onDismiss,
}: {
  onUpdate: () => void;
  onDismiss: () => void;
}) {
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 bg-[#0F1923] text-white text-sm font-medium px-4 py-3 rounded-full shadow-xl border border-white/10 max-w-[calc(100vw-2rem)]">
      <RefreshCw size={15} className="text-[#F5A623] flex-shrink-0" />
      <span className="whitespace-nowrap">New version available</span>
      <button
        type="button"
        onClick={onUpdate}
        className="ml-1 bg-[#F5A623] text-[#0F1923] text-xs font-bold px-3 py-1.5 rounded-full hover:opacity-90 transition-opacity"
      >
        Update now
      </button>
      <button
        type="button"
        onClick={onDismiss}
        className="text-white/40 hover:text-white/70 transition-colors text-xs px-1"
        aria-label="Dismiss"
      >
        ✕
      </button>
    </div>
  );
}
